import React, { FC } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { CssBaseline } from '@mui/material'
import { createStore, StateMachineProvider } from 'little-state-machine'
import { RootRoutes } from './RootRoutes'
import { AppStateProvider } from './components/Context'
import { ThemeConfig } from './theme'
import { Version } from './components/Version'

createStore(
  {},
  {
    name: 'sparling_financial',
  },
)

export const App: FC = () => (
  <StateMachineProvider>
    <CssBaseline />
    <ToastContainer />
    <AppStateProvider>
      <ThemeConfig>
        <RootRoutes />
        <Version />
      </ThemeConfig>
    </AppStateProvider>
  </StateMachineProvider>
)
